import { React, } from "react";
import {  Form, Input,  Col, Row, } from "antd";
import {
  HaberForm,
  RightDrawerContainer,
   DetailFields,
 } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";

import Iconmoon from "../../../Components/IconsFiles/icon";
import {CoversionFactorCMToUnits,CoversionFactorUnitsToCM,conversionFactorUnitsToTonne,conversionFactorTonneToUnits} from "../../../Utils/Constant/MeasurementUnitList.jsx"

const LengthConversionUnitDrawer = (props) => {
  const [form] = Form.useForm();

  return (
    <RightDrawerSidebar
      title={`Conversion of ${props.type === 'length' ? 'Lengths' : 'Weights'}`}
      subtitle=""
      visible={props.visible}
      onClose={() => {
        props.onClose();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm inputPadLeft">
          {/* Toasters */}

          {/* <AlertContainer color="blue" icon={alertBlue} msg="You can't modify a grade once added. A grade can only be deleted if there is no product created for that grade" /> */}
          {props.default ? (
            <DetailFields className="marginBtnP">
              <HaberForm>
                <Form
                  name="basic"
                  autoComplete="off"
                  className="haberLogin haberSignup"
                  style={{ marginTop: "0" }}
                  form={form}
                >
                  {props.selectedUnit.map((data,index) => {
                    return (
                      <Row className="centerAlign justifyCSBetween">
                        <Col span={5}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name  = {`unit${index}`}
                              rules={[{ required: true }]}
                              initialValue={data.displayName}
                              className="dBlock"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input  disabled style={{fontSize:"12px"}} />
                            </Form.Item>
                            <p style={{fontSize:"12px"}} >Unit</p>
                          </div>
                        </Col>
                        <Col
                          span={2}
                          style={{ paddingLeft: "4px", marginTop: "10px" }}
                        >
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Iconmoon icon="cancel" size={17} />
                          </div>
                        </Col>
                        <Col span={10}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name  = {`multiplier${index}`}
                              rules={[{ required: true }]}
                              initialValue={ props.type === 'length' ? ( (CoversionFactorUnitsToCM[data.value] * CoversionFactorCMToUnits[props.default])).toFixed(6) : ((conversionFactorUnitsToTonne[data.value] * conversionFactorTonneToUnits[props.default])).toFixed(6)}
                              className="dBlock"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input  disabled style={{fontSize:"12px"}}/>
                            </Form.Item>
                            <p style={{fontSize:"12px"}} >Multiplier to convert to default</p>
                          </div>
                        </Col>
                        <Col
                          span={2}
                          style={{ paddingLeft: "4px", marginTop: "10px" }}
                        >
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <label>
                              <Iconmoon icon="equal" size={16} />
                            </label>
                          </div>
                        </Col>
                        <Col span={5}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name  = {`default${index}`}
                              rules={[{ required: true }]}
                              initialValue={props.defaultDisplayName}
                              className="dBlock"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input  disabled style={{fontSize:"12px"}} />
                            </Form.Item>
                            <p style={{fontSize:"12px"}} >Default Unit</p>
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                </Form>
              </HaberForm>
            </DetailFields>
          ) : (
            <div
              className="titleWithText"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  padding: "0 15px 0 15px",
                  textAlign: "center",
                  marginTop: "60%",
                }}
              >
                <h5>
                  {`Conversion can be configured only after selecting a default
                  unit of ${props.type}`}
                </h5>
              </div>
            </div>
          )}
        </div>
        
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default LengthConversionUnitDrawer;
